import { render, staticRenderFns } from "./ColumnEdit.vue?vue&type=template&id=5979899c&scoped=true"
import script from "./ColumnEdit.vue?vue&type=script&lang=ts"
export * from "./ColumnEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5979899c",
  null
  
)

export default component.exports